import { POKE_DATA } from "game/data/pokemon/data";
import { POKEMON_SKILLS } from "game/data/skills/POKEMON_SKILLS";
import type { PokeNames } from "types/pokemon/poke-names";

/** Pokemon's known moves resolved against the skill registry (dash-cased ids match directly). */
export const getPokeSkills = (pokeName: string) => {
  const pokeData = POKE_DATA[pokeName as PokeNames];
  if (!pokeData) return [];
  return pokeData.moves
    .map((id) => POKEMON_SKILLS[id])
    .filter((skill): skill is NonNullable<typeof skill> => Boolean(skill));
};

export const SKILL_TYPE_LABEL: Partial<Record<string, string>> = {
  DAMAGE: "DMG",
  HEAL: "HEAL",
  SELF_HEAL: "HEAL",
  SHIELD: "SHIELD",
  SELF_SHIELD: "SHIELD",
  BUFF: "BUFF",
  DEBUFF: "DEBUFF",
  EVADE: "EVADE",
  GAP_CLOSE: "DASH",
};
